export default __webpack_public_path__ + "static/47-d91bffd5745d3c81197927d3cbdf50f3.png";